
















import { listFactory } from '@/main/pages';
import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, getCurrentLanguageId } from '@/main/utils/commonFunctions';
import { showAlert } from '@/main/utils/notifications';
import { NAME } from './constants';
import { apiProvider } from './api';
import { store } from './store/list';


export default listFactory(NAME, store).extend({
	methods: {
		async filterClick() {
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.OrganizationId,
				(columnsSeq) => ({
					CreatedFrom: this.CreatedFrom ? new Date(this.CreatedFrom!).toISOString() : '',
					CreatedTo: this.CreatedTo ? new Date(this.CreatedTo!).toISOString() : '',
					PracovnikId: this.loggedUser.UzivatelData.PracovnikId,
					SaleAbcFms: this.filter.SaleAbcFms,
					OrganizationId: this.OrganizationId,
					ColumnSequence: columnsSeq.join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
		async exportFun() {
			try {
				const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
				this.startLoading();
				let parameters = '';
				if (this.OrganizationId.length > 0) {
				this.OrganizationId.forEach((OrganizationId: any) => {
					parameters = parameters.concat(`&OrganizationId=${OrganizationId}`);
				});
			}
			if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
					await apiProvider.GetAbcFmsAnalysisReport(this.CreatedFrom ? new Date(this.CreatedFrom!).toISOString():"", this.CreatedTo ? new Date(this.CreatedTo!).toISOString():"",
					this.loggedUser.UzivatelData.PracovnikId, this.filter.SaleAbcFms ?? '', parameters, columnsSeq);
				}
			} catch (error) {
				showAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			}
			finally
			{
				this.endLoading();
			}
		},
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.OrganizationId);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.OrganizationId);
		},
		ABC_CATEGORY(): DropdownItem[] {
			return [
				{ Text: this.Localize('FREQUENCY'), Label: null, Disabled: false, Value: 1 },
				{ Text: this.Localize('SALE_VALUE'), Label: null, Disabled: false, Value: 2 },
			];
		},
	},
});
